import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TiUserDelete } from "react-icons/ti";
import { buildApiUrl } from "../utils/api";

function UserTable() {
    const [userData, setUserData] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(buildApiUrl('/api/user/getRegisteredUser'));
                setUserData(response.data); // Assuming the response contains the admin logins
            } catch (error) {
                console.error('Error fetching User data:', error);
            }
        };

        fetchUserData();
    }, []);
    const handleDeleteUser = async (email) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this user?");
        if (confirmDelete) {
            try {
                // Making a DELETE request to backend API
                const response = await axios.delete(buildApiUrl('/api/user/delete'), {
                    data: { email } // Send email in the request body
                });

                if (response.status === 200) {
                    alert('User deleted successfully!');

                    // Update the UI by removing the deleted user from the state
                    setUserData(userData.filter(user => user.email !== email));
                }
            } catch (error) {
                console.error("Error deleting user:", error);
                alert("Failed to delete the user");
            }
        }
    };

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>S.no</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Action</th>
                        {/* <th>Last Login</th> */}
                    </tr>
                </thead>
                <tbody>
                    {userData.map((user, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>End User</td>
                            <td>Status</td>
                            <td>
                            <button className='btn btn-danger' onClick={() => handleDeleteUser(user.email)}>
                                    <TiUserDelete style={{ fontSize: "25px" }} /> Delete User
                                </button>
                            </td>
                            {/* <td>{user.lastLogin}</td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default UserTable;
